import { cssVar } from '@chakra-ui/react';
const endColor = cssVar('skeleton-end-color');
const skeletonStyles = (tokens) => ({
    baseStyle: {
        [endColor.variable]: tokens.BorderLight200,
        borderRadius: tokens.BorderRadius02,
    },
});
export default skeletonStyles;
